import { createApp } from "vue"; // 改为从vue导入createApp
import App from "./App.vue";
import router from "./router";
import store from "./store";

// 导入Element Plus (Vue 3版本)
import 'element-plus/dist/index.css';

// 导入Vant (Vue 3版本)
import 'vant/lib/index.css';

// 单独导入Element Plus组件
import {
  ElInput,
  ElInputNumber,
  ElDatePicker,
  ElButton,
  ElSelect,
  ElOption,
  ElCheckbox,
  ElRow,
  ElCol,
  ElDialog,
  ElPopover,
  ElTabs,
  ElTabPane,
  ElTag,
  ElCarousel,
  ElCarouselItem,
  ElMain,
  ElForm,
  ElFormItem,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElTooltip,
  ElImage,
  ElTable,
  ElTableColumn,
  ElDivider,
  ElPagination,
  ElLoading,
  ElIcon,
  ElAside,
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElContainer,
  ElHeader,
  ElFooter,
  ElMessageBox,
  ElMessage,
  ElNotification,
  ElLink,
  ElRadioGroup,
  ElRadio,
  ElRate,
  ElTimePicker,
  ElTransfer,
  ElSwitch,
  ElCheckboxGroup,
  ElDescriptions,
  ElDescriptionsItem,
  ElCollapse,
  ElCollapseItem,
  ElCheckboxButton,
  ElConfigProvider
} from 'element-plus';

// 导入Vant组件
import {
  Calendar,
  IndexBar,
  IndexAnchor,
  Cell,
  CellGroup,
  Popup,
  Search,
  Sticky,
  Button as VantButton,
  DropdownMenu,
  DropdownItem,
  TreeSelect,
  RadioGroup,
  Radio,
  Tag as VantTag,
  NavBar,
  List,
  Swipe,
  SwipeItem,
  Toast,
  Tab,
  Tabs as VantTabs,
  Pagination as VantPage,
  Field,
  Form as VantForm,
  ActionSheet,
  AddressList,
  Switch as VantSwitch,
  Dialog as VantDialog,
  ContactList,
  DatePicker,
  Picker,
  Col as VantCol,
  Row as VantRow,
  Locale,
} from "vant";

import axios from "axios";

//vue 3rd party plugins
import i18n from "@/plugins/i18n";
import { currencySign } from "./config/currency";
import {
  getOperatorBasicInfo,
  getCustomerLookup,
  pointSearch,
  searchTravelApplyOrder,
  travelerLookup,
} from "@/api/platformData.js";
import getDictionaryData from "@/utils/getDictionaryData.js";
import { formatDateTime } from "@/utils/utils.js";
import directive from "@/utils/directive.js";
import interdeal from '@/utils/accessbility.js'
import "@/assets/stylus/fonts.styl";
import installSvgIcon from '@/icon/index.js' // 导入你的插件
// 创建Vue应用实例
const app = createApp(App);


// 使用Element Plus插件
app.use(installSvgIcon)
app.use(router);
app.use(store);
app.use(i18n);
// 按需注册Element Plus组件
app.use(ElInput);
app.use(ElInputNumber);
app.use(ElDatePicker);
app.use(ElButton);
app.use(ElSelect);
app.use(ElOption);
app.use(ElCheckbox);
app.use(ElRow);
app.use(ElCol);
app.use(ElTabs);
app.use(ElTabPane);
app.use(ElTag);
app.use(ElDialog);
app.use(ElPopover);
app.use(ElCarousel);
app.use(ElCarouselItem);
app.use(ElForm);
app.use(ElFormItem);
app.use(ElBreadcrumb);
app.use(ElBreadcrumbItem);
app.use(ElTooltip);
app.use(ElImage);
app.use(ElTable);
app.use(ElTableColumn);
app.use(ElDivider);
app.use(ElPagination);
app.use(ElLoading);
app.use(ElIcon);
app.use(ElAside);
app.use(ElMenu);
app.use(ElMenuItem);
app.use(ElMenuItemGroup);
app.use(ElMain);
app.use(ElContainer);
app.use(ElHeader);
app.use(ElFooter);
app.use(ElLink);
app.use(ElRadio);
app.use(ElRadioGroup);
app.use(ElRate);
// 注册Vant组件
app.use(IndexBar);
app.use(IndexAnchor);
app.use(Calendar);
app.use(Cell);
app.use(NavBar);
app.use(CellGroup);
app.use(Popup);
app.use(Search);
app.use(Sticky);
app.use(VantButton);
app.use(DropdownMenu);
app.use(DropdownItem);
app.use(TreeSelect);
app.use(Radio);
app.use(RadioGroup);
app.use(VantTag);
app.use(List);
app.use(Tab);
app.use(VantTabs);
app.use(VantPage);
app.use(VantForm);
app.use(Field);
app.use(Swipe);
app.use(SwipeItem);
app.use(Toast);
app.use(ElTimePicker);
app.use(ElTransfer);
app.use(ElSwitch);
app.use(ElCheckboxGroup);
app.use(ElDescriptions);
app.use(ElDescriptionsItem);
app.use(ActionSheet);
app.use(AddressList);
app.use(VantSwitch);
app.use(VantDialog);
app.use(ContactList);
app.use(ElCollapse);
app.use(ElCollapseItem);
app.use(ElCheckboxButton);
app.use(ElConfigProvider);
app.use(DatePicker);
app.use(Picker);
app.use(VantRow);
app.use(VantCol);

app.config.globalProperties.$loading = ElLoading.service;
app.config.globalProperties.$msgbox = ElMessageBox;
app.config.globalProperties.$alert = ElMessageBox.alert;
app.config.globalProperties.$confirm = ElMessageBox.confirm;
app.config.globalProperties.$prompt = ElMessageBox.prompt;
app.config.globalProperties.$notify = ElNotification;
app.config.globalProperties.$message = ElMessage;
app.config.globalProperties.$currencySign = currencySign;
//Vue.prototype.$getInitInfo = getInitInfo;
// Vue.prototype.$vConsole = new VConsole(); //console控制台
app.config.globalProperties.$objBaseInfo = {}; //用户信息
app.config.globalProperties.$dictionaryData = {}; //数据字典
app.use(directive); //注册dialog拖拽指令
//CSP unsafe-inline unsafe-eval 改成 nonce
// const nonce = Math.random().toString(36).substring(2);
// Vue.prototype.$nonce = nonce;
// const meta = document.querySelector('meta[name="CSP"]');
// var nonces = "'nonce-" + nonce +"'";
// if (meta) {
  
//   meta.setAttribute('content', "default-src 'self' *.chuxingpay.com *.mycwt.com.cn *.optimizely.com *.appdynamics.com pdx-col.eum-appdynamics.com at.alicdn.com *.is.autonavi.com *.amap.com blob: data:; script-src 'self' 'unsafe-inline' 'unsafe-eval';style-src 'unsafe-inline' 'unsafe-eval' 'self' "+ nonces +"")
//   //meta = meta.replace(/nonce__to_replace__/g, nonces );
//   //alert(meta);
//   console.log(meta);
// }
function parseRoomitMessage(data) {
  // 兼容跨页面传参：既支持对象，也支持 JSON 字符串。
  if (!data) {
    return null;
  }
  let payload = data;
  if (typeof data === "string") {
    try {
      payload = JSON.parse(data);
    } catch (e) {
      return null;
    }
  }
  if (
    payload &&
    payload.type === "ROOMIT_SSO_TOKEN" &&
    typeof payload.token === "string" &&
    payload.token
  ) {
    return payload;
  }
  return null;
}

function waitForRoomitSsoToken(timeoutMs = 10000) {
  return new Promise((resolve) => {
    let done = false;
    const timer = window.setTimeout(() => {
      if (done) return;
      done = true;
      window.removeEventListener("message", onMessage);
      resolve(null);
    }, timeoutMs);

    const onMessage = (event) => {
      const payload = parseRoomitMessage(event.data);
      if (!payload || done) {
        return;
      }
      done = true;
      window.clearTimeout(timer);
      window.removeEventListener("message", onMessage);
      resolve(payload);
    };

    window.addEventListener("message", onMessage);
  });
}

//从CRM、OBT跳转过来带token
let params = new URLSearchParams(location.search);
let token = params.get("token");
let sourceType = params.get("sourceType"); //来源
let messageLang = null;
let messageDestinationType = null;
const hasTokenInUrl = !!token;
let searchParam = params.get("searchParam")
  ? JSON.parse(params.get("searchParam"))
  : null;

function resolveTokenFromWindowName() {
  // 读取跳转前写入 window.name 的一次性 SSO 数据。
  const payload = parseRoomitMessage(window.name);
  if (!payload) {
    return null;
  }
  // 消费后清空，避免刷新时重复使用旧 token。
  window.name = "";
  return payload;
}

function applyRuntimeLanguage(langValue) {
  if (!langValue) {
    return;
  }
  // 立刻应用语言，保证首屏即使用 URL/消息中的语言设置。
  const localeValue = langValue === "zh-CN" ? "zh" : "en";
  localStorage.setItem("language", localeValue);
  i18n.global.locale = localeValue;
  Locale.use(localeValue, i18n.global.getLocaleMessage(localeValue));
}

function continueBootstrapWithToken() {
  if (sourceType == "OBT") {
    sessionStorage.setItem("isFirstIntoResult", true); //第一次进入列表页
  }
  if (token || sourceType) {
    sessionStorage.setItem("pathSource", sourceType); //存储来源
    if (token) {
      localStorage.setItem("token_" + sourceType, token); //存储token 格式：token_CRM,token_OBT
      const langValue = messageLang || params.get("lang");
      applyRuntimeLanguage(langValue);
      const destinationTypeValue = messageDestinationType || params.get("destinationType");
      if (destinationTypeValue)
        sessionStorage.setItem(sourceType + "destinationType", destinationTypeValue); //destinationType D代表国内 I代表国际
      if (!sourceType) {
        alert("请传入来源");
      }
      sessionStorage.setItem(sourceType + "LastOrderNo", params.get("Last_OrderNo") ? params.get("Last_OrderNo") : ""); //OBTLastOrderNo/CRMLastOrderNo
      if (sourceType == "OBT") {
        //增加OBT参数获取
        sessionStorage.setItem("OBTItineraryOrder", params.get("Next_OrderNo") ? params.get("Next_OrderNo") : "");
      } else {
        sessionStorage.removeItem("OBTItineraryOrder");
      }
      if (hasTokenInUrl) {
        const newUrl = window.location.pathname + window.location.search.replace(/[?&]token=[^&]*/, '');
        window.history.replaceState({}, '', newUrl);
      }
    } else {
      token = localStorage.getItem("token_" + sourceType);
      const destinationTypeValue = messageDestinationType || params.get("destinationType");
      if (destinationTypeValue)
        sessionStorage.setItem(sourceType + "destinationType", destinationTypeValue); //destinationType D代表国内 I代表国际
    }

    if (sourceType == "CRM") {
      //CRM 传入'客户customerCode'不是当前登录人customerCode;
      if (params.get("customerCode")) {
        //CRM 访问result页面，传入'联系人userCode'不是当前登录人loginID
        if (params.get("userCode"))
          getInitInfo(params.get("customerCode"), params.get("userCode"));
        else getInitInfo(params.get("customerCode"));
      } else {
        //CRM 访问订单补录页面不需要获取用户信息
        getInitInfo();
      }
    } else {
      getInitInfo();
    }
  } else {
    //alert("用户未登录，请重新再试！");

    //获取用户token信息
    //开发时默认赋值
    localStorage.setItem("language", "zh"); //存储语言
    // axios
    //   // .get("/roomit/platform/dev/v1/user/getToken", {
    //   .get("/sit/v1/user/getToken", {
    //     params: {
    //       loginID: "CWT_WLu",
    //       passWord: "$2a$10$U8.e3JAE4hxI83xg2slG5Om9w1iGvMo4H/7PhopFOFRd9ak15uoxm",
    //       //YGO00008
    //       // loginID: "LiteHamilton",
    //       // passWord: "82eeec044fdbedf4d0e4c42cb6b06c73",
    //       sourceType: "OBT", //类型
    //     },
    //   })
    //   .then(function (response) {
    //     //获取登录人token
    //     localStorage.setItem("token_OBT", response.data.data.token);
    //     sessionStorage.setItem("pathSource", "OBT"); //存储来源
    //     sessionStorage.setItem("OBTdestinationType", "D"); //
    //     getInitInfo();
    //   })
    //   .catch(function (error) {
    //     console.log("main.js token 请求失败", error);
    //     createdVue();
    //   });
  }
}

if (!token) {
  // 优先级1：优先读取 opener 通过 window.name 传递的 token。
  const namePayload = resolveTokenFromWindowName();
  if (namePayload) {
    token = namePayload.token;
    sourceType = namePayload.sourceType || sourceType;
    messageLang = namePayload.lang || null;
    messageDestinationType = namePayload.destinationType || null;
  }
}
if (!token && sourceType) {
  // 优先级2：回退读取当前 sourceType 对应的本地缓存 token。
  const localToken = localStorage.getItem("token_" + sourceType);
  if (localToken) {
    token = localToken;
    continueBootstrapWithToken();
  } else {
    // 优先级3：等待异步 postMessage 传递 SSO 数据。
    waitForRoomitSsoToken().then((messagePayload) => {
      if (messagePayload) {
        token = messagePayload.token;
        sourceType = messagePayload.sourceType || sourceType;
        messageLang = messagePayload.lang || null;
        messageDestinationType = messagePayload.destinationType || null;
      }
      continueBootstrapWithToken();
    });
  }
} else {
  continueBootstrapWithToken();
}

function getInitInfo(customerCodeFromCRM, userCodeFromCRM) {
  const objBaseInfo = {};
  console.log("手机屏幕宽度", document.body.clientWidth);
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    objBaseInfo.channelId = "MOBILE"; // 平台类型
    objBaseInfo.jumpType = "H5"; // 平台类型
  } else {
    objBaseInfo.channelId = "WEB";
    objBaseInfo.jumpType = "PC"; // 平台类型
  }

  //destinationType D代表国内 I代表国际
  objBaseInfo.destinationType = sessionStorage.getItem(sessionStorage.getItem("pathSource") + "destinationType");

  //获得CRM国家Code
  if (params.get("countryCode"))
    objBaseInfo.countryCode = params.get("countryCode");
  else objBaseInfo.countryCode = "100000";

  // 国内 是否是港澳台
  objBaseInfo.isGATCity = false;
  // 列表页差规打标如下企业去掉打标提示
  let policySwitch = ['YGO00405','YGO00492','YGO00493','YGO00500','YGO00501','YGO00502','YGO00503','YGO00504','YGO00505','YGO00506','YGO00508','YGO00510','YGO00512'];
  objBaseInfo.policySwitch = true;
  objBaseInfo.personalizationPolicySwitch = true;
  objBaseInfo.showTravelTitle = true;
  objBaseInfo.displayTravelRules = true;
  // 判断是否存在url中是否存在仅查询操作
  if (searchParam && searchParam.isOnlySearch) {
    objBaseInfo.isOnlySearch = searchParam.isOnlySearch == "0";
  };
  // 获取登录人信息
  getOperatorBasicInfo()
    .then((res) => {
      if (res.code === 200) {
        objBaseInfo.loginUserCode = res.data.userCode; //当前登录人的User code
        objBaseInfo.userCode = customerCodeFromCRM ? customerCodeFromCRM : res.data.userCode; //当从CRM跳转过来时，存放CRM选的客户信息; 其他情况存放登录人的客户信息即User code。
        objBaseInfo.customerCode = objBaseInfo.userCode; //同userCode
        //objBaseInfo.policySwitch = policySwitch.indexOf(objBaseInfo.userCode) != -1 ? false : true ;
        objBaseInfo.loginID = userCodeFromCRM ? userCodeFromCRM : res.data.loginID; //登陆人loginID，当从CRM跳转过来时，存放CRM选的联系人的loginID
        objBaseInfo.hotelBookingRole = res.data.hotelBookingRole
          ? res.data.hotelBookingRole
          : ""; //当前登录人预订权限 1 - Traveler, 2 - Travel Arranger, 3 - Travel Counselor;
        objBaseInfo.userName = res.data.userName ? res.data.userName : ""; //登陆人姓名
        objBaseInfo.quanPin = res.data.subAccount.quanPin
          ? res.data.subAccount.quanPin
          : "";
        objBaseInfo.userNameQuanPin = res.data.subAccount.userNameQuanPin
          ? res.data.subAccount.userNameQuanPin
          : "";
        if (res.data.subAccount.loginUserPermission) {
          objBaseInfo.viewDepIDs = res.data.subAccount.loginUserPermission
            .viewDepIDs
            ? res.data.subAccount.loginUserPermission.viewDepIDs
            : ""; //出行员工部门ids
          objBaseInfo.viewUserIDs = res.data.subAccount.loginUserPermission
            .viewUserIDs
            ? res.data.subAccount.loginUserPermission.viewUserIDs
            : ""; //出行员工ids
          objBaseInfo.bookBy = res.data.subAccount.loginUserPermission.bookBy
            ? res.data.subAccount.loginUserPermission.bookBy
            : "";
          objBaseInfo.bookDepIDs = res.data.subAccount.loginUserPermission
            .bookDepIDs
            ? res.data.subAccount.loginUserPermission.bookDepIDs
            : "";
          objBaseInfo.bookUserIDs = res.data.subAccount.loginUserPermission
            .bookUserIDs
            ? res.data.subAccount.loginUserPermission.bookUserIDs
            : "";
          objBaseInfo.viewBy = res.data.subAccount.loginUserPermission.viewBy
            ? res.data.subAccount.loginUserPermission.viewBy
            : "";
          objBaseInfo.pkid = res.data.subAccount.pkid ? res.data.subAccount.pkid : ""; //id
        } else {
          objBaseInfo.viewDepIDs = ""; //出行员工部门ids
          objBaseInfo.viewUserIDs = ""; //出行员工ids
          objBaseInfo.bookBy = "";
          objBaseInfo.bookDepIDs = "";
          objBaseInfo.bookUserIDs = "";
          objBaseInfo.viewBy = "";
        }
        objBaseInfo.mobilePhone = res.data.mobilePhone
          ? res.data.mobilePhone
          : ""; //登陆人手机号
        objBaseInfo.eMail = res.data.eMail ? res.data.eMail : ""; //登陆人邮箱
        objBaseInfo.staffNum = res.data.subAccount.staffNum
          ? res.data.subAccount.staffNum
          : ""; //登陆人员工号
        objBaseInfo.userLevel = res.data.subAccount.userLevel
          ? res.data.subAccount.userLevel
          : ""; //职级
        objBaseInfo.costCenterID = res.data.subAccount.costCenterID
          ? res.data.subAccount.costCenterID
          : ""; //登陆人成本中心编码
        objBaseInfo.departmentCode = res.data.subAccount.departmentID.toString()
          ? res.data.subAccount.departmentID.toString()
          : ""; // 部门编号
        objBaseInfo.departmentName = res.data.subAccount.departmentName
          ? res.data.subAccount.departmentName
          : ""; // 部门名称
        objBaseInfo.sourceType = res.data.sourceType ? res.data.sourceType : sourceType; //来源
        objBaseInfo.extraBooking = res.data.subAccount.extraBooking ? res.data.subAccount.extraBooking : ""; //预订人 临客权限
        objBaseInfo.nameListType = res.data.subAccount.nameListType ? res.data.subAccount.nameListType : ""; //白名单 1：是 0：不是
        objBaseInfo.nameListProduct = res.data.subAccount.nameListProduct ? res.data.subAccount.nameListProduct : ""; //白名单类型
        objBaseInfo.linkerEmail = res.data.subAccount.linkerEmail ? res.data.subAccount.linkerEmail : ""; //联系人邮箱
        objBaseInfo.linkerMobile = res.data.subAccount.linkerMobilePhone ? res.data.subAccount.linkerMobilePhone : ""; //联系人手机号
        objBaseInfo.linkerName = res.data.subAccount.linkerName ? res.data.subAccount.linkerName : ""; //联系人姓名
        objBaseInfo.birthday = res.data.subAccount.birthday ? res.data.subAccount.birthday : ""; //出生日期
        objBaseInfo.idCardNumber = res.data.subAccount.userPaperInfo.cardID ? res.data.subAccount.userPaperInfo.cardID : ""; //身份证号
        objBaseInfo.passportNumber = res.data.subAccount.userPaperInfo.cardType ? res.data.subAccount.userPaperInfo.cardType : ""; //护照号
        objBaseInfo.visaCountry = res.data.subAccount.userPaperInfo.visaCountry ? res.data.subAccount.userPaperInfo.visaCountry : ""; //护照签发国
        objBaseInfo.sex = res.data.subAccount.sex ? res.data.subAccount.sex : ""; //性别
        objBaseInfo.isComplete = res.data.subAccount.userPaperInfo ? res.data.subAccount.userPaperInfo.isComplete : true;
        // CRM获取预订联系人的权限
        if (objBaseInfo.sourceType == "CRM" && userCodeFromCRM) {
          let travelerParam = {
            params: {
              companyCode: objBaseInfo.customerCode,
              travelerCode: userCodeFromCRM,
            },
          };
          travelerLookup(travelerParam)
            .then((res) => {
              if (res.code === 200) {
                if (res.data.error.code != 0) {
                  console.log("出行人信息请求失败, code:", res.data.error.code, res.data.error.message);
                } else {
                  let traveler = res.data.travelerList[0];
                  objBaseInfo.userName = traveler.travelerName;
                  objBaseInfo.mobilePhone = traveler.mobile;
                  objBaseInfo.eMail = traveler.email;
                  objBaseInfo.staffNum = traveler.staffNum;
                  objBaseInfo.costCenterID = traveler.costCenter;
                  objBaseInfo.userLevel = traveler.userLevel;
                  objBaseInfo.pkid = traveler.pkId;
                  objBaseInfo.userNameQuanPin = traveler.userNameQuanPin;
                  objBaseInfo.hotelBookingRole = traveler.hotelBookingRole; // CRM联系人的预订权限
                  objBaseInfo.nameListType = traveler.isWhiteList ? 1 : 0; //白名单 1：是 0：不是
                  objBaseInfo.nameListProduct = traveler.whiteProduct ? traveler.whiteProduct : ""; //白名单类型
                  objBaseInfo.extraBooking = traveler.extraBooking ? traveler.extraBooking : ""; //预订人 临客权限
                  objBaseInfo.departmentCode = traveler.departmentID.toString();
                  objBaseInfo.departmentName = traveler.departmentName;
                  objBaseInfo.viewDepIDs = traveler.viewDepIDs ? traveler.viewDepIDs : ""; //出行员工部门ids
                  objBaseInfo.viewUserIDs = traveler.viewUserIDs ? traveler.viewUserIDs : ""; //出行员工ids
                  objBaseInfo.bookBy = traveler.bookBy ? traveler.bookBy : "";
                  objBaseInfo.bookDepIDs = traveler.bookDepIDs ? traveler.bookDepIDs : "";
                  objBaseInfo.bookUserIDs = traveler.bookUserIDs ? traveler.bookUserIDs : "";
                  objBaseInfo.viewBy = traveler.viewBy ? traveler.viewBy : "";
                  objBaseInfo.languageValue = traveler.languageValue? traveler.languageValue : "zh-CN";//语言偏好
                  objBaseInfo.linkerEmail = traveler.linkerEmail ? traveler.linkerEmail : ""; //联系人邮箱
                  objBaseInfo.linkerMobile = traveler.linkerMobilePhone ? traveler.linkerMobilePhone : ""; //联系人手机号
                  objBaseInfo.linkerName = traveler.linkerName ? traveler.linkerName : ""; //联系人姓名
                  objBaseInfo.birthday = traveler.birthday ? traveler.birthday : ""; //出生日期
                  objBaseInfo.idCardNumber = traveler.userPaperInfo.cardID ? traveler.userPaperInfo.cardID : ""; //身份证号
                  objBaseInfo.passportNumber = traveler.userPaperInfo.cardType ? traveler.userPaperInfo.cardType : ""; //护照号
                  objBaseInfo.visaCountry = traveler.userPaperInfo.visaCountry ? traveler.userPaperInfo.visaCountry : ""; //护照签发国
                  objBaseInfo.sex = traveler.sex ? traveler.sex : ""; //性别
                  objBaseInfo.isComplete = traveler.userPaperInfo ? traveler.userPaperInfo.isComplete : true;
                }
              } else {
                console.log("出行人信息请求错误, code:" , res.code, res.message);
              }
            })
            .catch(function (error) {
              console.log("出行人信息请求错误", error.objError);
            });
        }
        // 判断是否存在url中是否存在行程单单号字段
        if (searchParam && searchParam.tripApplyNo) {
          let travelApplyOrderParam = {
            params: {
              userCode: objBaseInfo.userCode,
              userID: objBaseInfo.loginID,
              tripOrderNo: searchParam.tripApplyNo,
            },
          };
         searchTravelApplyOrder(travelApplyOrderParam)
            .then((res) => {
              if (res.code === 200) {
                if (res.data.error.code != 0) {
                  console.log("出差单信息请求失败, code:" , res.data.error.code, res.data.error.message);
                } else {
                  if (res.data && res.data.tripOrderList) {
                    let trip = res.data.tripOrderList[0];
                    let tripTemp = {
                      triporderNo: trip.triporderno, //系统行程单号
                      customerOrderNo: trip.customerOrderNo, //客户行程单号
                      locationCode: trip.location[0].locationCode,
                      checkInDate: trip.location[0].checkInDate ? formatDateTime(trip.location[0].checkInDate, "YYYY-MM-DD") : "",
                      checkOutDate: trip.location[0].checkOutDate ? formatDateTime(trip.location[0].checkOutDate, "YYYY-MM-DD") : "",
                      checkInDateBegin: trip.location[0].checkInDateBegin? formatDateTime(trip.location[0].checkInDateBegin, "YYYY-MM-DD") : "",
                      checkInDateEnd: trip.location[0].checkInDateEnd? formatDateTime(trip.location[0].checkInDateEnd, "YYYY-MM-DD") : "",
                      checkOutBegin: trip.location[0].checkOutBegin? formatDateTime(trip.location[0].checkOutBegin, "YYYY-MM-DD") : "",
                      checkOutEnd: trip.location[0].checkOutEnd? formatDateTime(trip.location[0].checkOutEnd, "YYYY-MM-DD") : "",
                      userID: trip.travelers[0].userID,
                      userName: trip.travelers[0].userName,
                      mobile: trip.travelers[0].mobile,
                      email: trip.travelers[0].email,
                      sex: trip.travelers[0].sex,
                      employeeID: trip.travelers[0].employeeID,
                      costCenter: trip.travelers[0].costCenter,
                      travelers: trip.travelers,
                      location: trip.location,
                      createBy: trip.createBy,
                    };
                    sessionStorage.setItem("tripOrder", JSON.stringify(tripTemp));
                    objBaseInfo.tripOrderInfo = tripTemp;
                  }
                }
              } else {
                console.log("出差单信息请求失败, code:" , res.code, res.message);
              }
              getCompanyAndPos(customerCodeFromCRM, userCodeFromCRM,objBaseInfo);
            })
            .catch((error) => {
              console.log("出差单信息请求异常", error.objError);
              getCompanyAndPos(customerCodeFromCRM, userCodeFromCRM,objBaseInfo);
            });
        } else {
          if (new URLSearchParams(location.search).get("token")) {
            //如果有searchParam 没有tripApplyNo 代表CRM或者OBT没有传行程单
            sessionStorage.removeItem("tripOrder");
          } else {
            // 临时解决页面刷新 行程单无数据问题
            //页面刷新
            let localTripOrder = sessionStorage.getItem("tripOrder");
            if (localTripOrder) {
              objBaseInfo.tripOrderInfo = JSON.parse(localTripOrder);
            }
          }
          getCompanyAndPos(customerCodeFromCRM, userCodeFromCRM,objBaseInfo);
        }
      } else {
        console.log("登录人信息err:", res);
      }
    })
    .catch(function (error) {
      console.log("登录人信息 请求失败", error.objError);
    });

  //获取数据字典信息
  getDictionaryData();
}

function getCompanyAndPos(customerCodeFromCRM, userCodeFromCRM,objBaseInfo) 
{
     // 获取到登陆人code
     let params = {
      params: {
        customerCode: objBaseInfo.userCode,
        channelID: "WEB", //objBaseInfo.channelId,
      }, //channelID 暂时不传，如果传后端要改逻辑
    };
    //获取公司信息, 和Point Sale信息
    axios
      .all([getCustomerLookup(params), pointSearch(params)])
      .then(
        axios.spread((customer, point) => {
          let isHasPointSale = false;
          //公司信息
          if (customer.code === 200) {
            if (customer.data.customerDetails.length > 0) {
              //是否开启行程单，强弱管控
              let cusInfo = customer.data.customerDetails[0];
              objBaseInfo.strongControl = cusInfo.strongControl; //强弱管控
              objBaseInfo.ordApprovalType = cusInfo.ordApprovalType
                ? cusInfo.ordApprovalType
                : 0; //是否开启行程单
              // 国际酒店目前不支持"行前审批"
              // if (objBaseInfo.destinationType == "I") {
              //   objBaseInfo.ordApprovalType = 0;
              // }
              if (
                objBaseInfo.ordApprovalType == 0 &&
                sessionStorage.getItem("tripOrder")
              ) {
                sessionStorage.removeItem("tripOrder");
                objBaseInfo.tripOrderInfo = null;
              }
              objBaseInfo.customerTcs = cusInfo.customerTcs; //tc服务小组
              objBaseInfo.customerName = cusInfo.customerName;
              objBaseInfo.isCorpPay = cusInfo.isCorpPay;
              sessionStorage.setItem('linkerValue', cusInfo.linkerValue);
            } else {
              objBaseInfo.ordApprovalType = 0;
            }
          } else {
            console.log("公司信息err:", customer);
          }
          //Point Sale信息
          if (point.code === 200) {
            if (point.data.list.length > 0) {
              isHasPointSale = true;
              let posData = point.data.list[0];
              objBaseInfo.poscode = posData.poscode;
              const hotelSettings = posData.hotelSettings[0];
              objBaseInfo.maximumNumberProperties = hotelSettings.maximumNumberProperties || 0; // 每页显示条数
              objBaseInfo.maximumDaysAdvance = hotelSettings.maximumDaysAdvance || 0; // 允许预订的日期
              objBaseInfo.maxNights = hotelSettings.maximumNumberNights; // 最大间夜数(可入住最大天数)
              objBaseInfo.maxRoom = hotelSettings.maximumNumberRooms; // 最大房间数
              objBaseInfo.maxAdult = hotelSettings.maximumNumberAdultsAllowedRoom; // 房间最大人数
              objBaseInfo.filterUnmappedRates = hotelSettings.filterUnmappedRates;
              objBaseInfo.filterPrepayRates = hotelSettings.filterRepayRates;
              objBaseInfo.filterNonrefundableRate = hotelSettings.filterNonRefundableRates;
              objBaseInfo.filterNonGDSGuaranteeRates = hotelSettings.filterNonGdsguarabteeRates;
              objBaseInfo.filterBurRates = hotelSettings.filterBurRates;
              objBaseInfo.isShowChainWide = hotelSettings.isShowChainWide; // 是否展示ChainWide酒店标识
              objBaseInfo.onlyShowBestPrice = hotelSettings.onlyShowBestPrice; // 只展示最优价格
              objBaseInfo.defaultCurrencyCode = "";
              objBaseInfo.defaultCurrencySign = "";
              objBaseInfo.notice = posData.uiSettings.length > 0 ? posData.uiSettings[0].notice : "";
              objBaseInfo.uiAnnoucementSettings = posData.uiAnnoucementSettings;
              //根据配置来显示是否展示差规提示
              if(posData.posHotelTravelRule){
                objBaseInfo.policySwitch = posData.posHotelTravelRule.isTripRuleMarkInHotelList;//浮窗是否展示
                objBaseInfo.showTravelTitle = posData.posHotelTravelRule.isShowTravelTitle;
                objBaseInfo.personalizationPolicySwitch = posData.posHotelTravelRule.isFloatWindowPersonalization;//浮窗个性化设置
              }
              //根据配置来显示是否展示服务费
              objBaseInfo.posItineraryModel = posData.posItineraryModel;
              objBaseInfo.ctCity = posData.ctCity;
              objBaseInfo.posrc = posData.posrc;
              objBaseInfo.showOtherProduct_PC = posData.hotelSettings[0].bookOtherPc;
              objBaseInfo.showOtherProduct_H5 = posData.hotelSettings[0].bookOtherH5;
              objBaseInfo.notRecommendedModel = posData.notRecommendedModel;
              objBaseInfo.posCostCenterModel = posData.posCostCenterModel;
              objBaseInfo.openResource = "";
              if(posData.hotelSettings[0].hasOwnProperty("openResource"))
              {
                 objBaseInfo.openResource = posData.hotelSettings[0].openResource;
              }
              objBaseInfo.itineraryLanguageSet = posData.hotelSettings[0].itineraryLanguageSet;
              if(posData.isAccessbility &&objBaseInfo.sourceType != "CRM")
              {
                Loadaccessbility();
              }

            } else {
              if (window.location.pathname.indexOf("/result") > -1) {
                alert("提示：该客户未做POS配置，请联系Setup小组!");
                console.log("获取不到Point Sale信息。提示：该客户未做POS配置，请联系Setup小组!");
              } else {
                isHasPointSale = true;
                if (window.location.pathname.indexOf("/orderList") < 0) {
                  console.log("获取不到Point Sale信息。");
                }
              }
            }
          } else {
            console.log("Point Sale error:", point);
          }

          // 设置全局属性
          app.config.globalProperties.$objBaseInfo = objBaseInfo;
          // console.log("基本信息：", JSON.stringify(objBaseInfo));
          if (isHasPointSale) mountApp(); //如果有PointSale信息才显示页面
        })
      )
      .catch(function (error) {
        console.log("公司信息和Point Sale信息 请求失败", error.objError);
      });

}

function Loadaccessbility(){
  (function(doc, head, body){
    window.interdeal=interdeal.interdeal;
    var coreCall= doc.createElement('script');
    console.log(interdeal.interdeal  );
    coreCall.src= interdeal.interdeal.domains.js + 'core/5.0.8/accessibility.js';
    coreCall.defer= true;
    coreCall.integrity = 'sha512-DL4HncZs4SCAd8KqE2GWIK5NNVuoXkdhiYOwOy8/9ZKNyYN48XNdS3peJ22GmNR1AnHJuFHEtdFMgCEDONyKWQ==';
    coreCall.crossOrigin = 'anonymous';
    coreCall.setAttribute('data-cfasync', true );
    body? body.appendChild(coreCall) : head.appendChild(coreCall);
  })(document, document.head, document.body);
}

// 挂载应用
function mountApp() {
  app.mount("#app");
}